import { useState, useEffect, useRef } from "react";

export function useCountdownTimer(initialTime, onExpire) {
	const [timeLeft, setTimeLeft] = useState(initialTime);
	const callbackRef = useRef(onExpire);

	// Keep callback ref current
	useEffect(() => {
		callbackRef.current = onExpire;
	});

	// Update timeLeft when initialTime changes (session data loads)
	useEffect(() => {
		setTimeLeft(initialTime);
	}, [initialTime]);

	useEffect(() => {
		if (timeLeft <= 0) {
			callbackRef.current?.();
			return;
		}

		const timer = setTimeout(() => {
			setTimeLeft((prev) => prev - 1);
		}, 1000);

		return () => clearTimeout(timer);
	}, [timeLeft]);

	return timeLeft;
}
